import {Box, Stack, Tooltip, Typography} from "@mui/material";
import {c, mono} from "../landingTokens";
import {Section} from "./Shell";
import axiansLogo from "../../../assets/images/axians.webp";
import finkiLogo from "../../../assets/images/finki.png";
import fitrLogo from "../../../assets/images/fitr.png";
import zanMitrevLogo from "../../../assets/images/zan-mitrev.png";

const PARTNERS = [
    {name: "FINKI", image: finkiLogo, href: "https://finki.ukim.mk/", maxHeight: 88, maxWidth: 118},
    {name: "Axians", image: axiansLogo, href: "https://www.axians.mk/", maxHeight: 52, maxWidth: 220},
    {name: "FITR", image: fitrLogo, href: "https://fitr.wearetribeca.io/", maxHeight: 72, maxWidth: 138},
    {
        name: "Zan Mitrev Clinic",
        image: zanMitrevLogo,
        href: "https://zmc.mk/",
        maxHeight: 92,
        maxWidth: 116,
        offsetY: 8
    },
];

export const Partners = () => (
    <Section label="Partners" sx={{textAlign: "center"}}>
        <Typography sx={{
            fontFamily: mono,
            fontSize: "11.5px",
            letterSpacing: "0.16em",
            textTransform: "uppercase",
            color: c.purpleDeep,
            mb: 4.25
        }}>
            Built and backed with
        </Typography>

        <Stack
            sx={{
                display: "grid",
                gridTemplateColumns: {
                    xs: "1fr",
                    sm: "repeat(4, minmax(0, 1fr))",
                },
                gap: {xs: 1.5, sm: 2.25},
                alignItems: {xs: "stretch", sm: "end"},
            }}
        >
            {PARTNERS.map((partner) => (
                <Tooltip key={partner.name} title={partner.name} arrow>
                    <Box
                        component={partner.href ? "a" : "div"}
                        href={partner.href}
                        target={partner.href ? "_blank" : undefined}
                        rel={partner.href ? "noopener noreferrer" : undefined}
                        sx={{
                            width: "100%",
                            height: 112,
                            boxSizing: "border-box",
                            border: "none",
                            borderRadius: "22px",
                            bgcolor: "transparent",
                            textDecoration: "none",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            px: 2,
                            transition: "transform 220ms ease",
                            "&:hover": {
                                transform: "scale(1.05)",
                            },
                        }}
                    >
                        <Box
                            component="img"
                            src={partner.image}
                            alt={partner.name}
                            sx={{
                                maxWidth: partner.maxWidth || "100%",
                                maxHeight: partner.maxHeight || 68,
                                objectFit: "contain",
                                clipPath: "none",
                                filter: "grayscale(1) contrast(0.9)",
                                opacity: 0.68,
                                transform: partner.offsetY ? `translateY(${partner.offsetY}px)` : "none",
                                transition: "filter .2s ease, opacity .2s ease, transform .2s ease",
                                "&:hover": {
                                    filter: "grayscale(0) contrast(1)",
                                    opacity: 1,
                                    transform: `translateY(${partner.offsetY || 0}px)`
                                },
                            }}
                        />
                    </Box>
                </Tooltip>
            ))}
        </Stack>
    </Section>
);
